var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',{staticClass:"suggestion-info",attrs:{"trigger":_vm.isMd ? 'hover' : 'clickToOpen',"options":{
    placement: _vm.isMd ? 'top' : 'left',
  }}},[_c('span',{staticClass:"popper"},[_c('span',{staticClass:"popper__content",domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('button',{staticClass:"suggestion-info__btn",attrs:{"slot":"reference"},slot:"reference"},[_c('base-icon',{attrs:{"name":"info","width":"24","height":"24"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }